import { memo } from "react";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Stats } from "./components/Stats";
import { Features } from "./components/Features";
import { Modules } from "./components/Modules";
import { Pricing } from "./components/Pricing";
import { Footer } from "./components/Footer";

export const LandingPage = memo(function LandingPage() {
  return (
    <>
      <Navbar />
      <main id="main-content">
        <Hero />
        <Stats />
        <Features />
        <Modules />
        <Pricing />
      </main>
      <Footer />
    </>
  );
});
